import { AudioManager } from "../../../AudioManager";
import { GameManager } from "../../../GameManager";
import { GameVars } from "../../../GameVars";
import { SplashScene } from "../SplashScene";
import { CategoryLayer } from "./CategoryLayer";
import * as Mahjong from "@ravalmatic/mahjong-engine";

export class BoardInfoContainer extends Phaser.GameObjects.Container {

    private boardData: Mahjong.BoardData;

    constructor(scene: Phaser.Scene, data: {boardData: Mahjong.BoardData, status: number}) {
        
        super(scene);

        const gameText = this.scene.cache.json.get("text");
        const lan = GameVars.gameData.data.language;

        this.boardData = data.boardData;

        const background =  new Phaser.GameObjects.Image(scene, 0, 0, "texture_atlas_1", "board-capsule-background");
        this.add(background);

        let time: number = null;

        const levelsData = GameVars.gameData.categoriesData[this.boardData.cat].levelsData;

        for (let i = 0; i < levelsData.length; i++) {

            if (levelsData[i].id === this.boardData.id) {

                time = levelsData[i].time;

                break;
            }
        }

        if (data.status === 1 || data.status === 2) {

            const atlasTexture = this.scene.textures.get("texture_atlas_2");
            let textureAtlas = atlasTexture.has(this.boardData.id) ? "texture_atlas_2" : "texture_atlas_3";
    
            const thumb = new Phaser.GameObjects.Image(scene, 0, -35, textureAtlas, this.boardData.id);
            this.add(thumb);

            background.setInteractive({useHandCursor: true});
            background.on("pointerup", this.onBoardUp, this);

            const name = new Phaser.GameObjects.Text(scene, 0, 40, this.boardData.name, {fontFamily: "OpenSans-CondLight", fontSize: "40px", color: "#7C5D46"});
            name.setOrigin(.5);
            this.add(name);
    
            let height = name.height;
            let width = name.width; 
    
            name.setScale(32 / height);
    
            width *= 32 / height;
    
            if (width > 160) {
                name.setScale(160 / name.width);
            }

            if (data.status === 1) {

                const notCompletedLabel = new Phaser.GameObjects.Text(scene, 0, 80, gameText.NOT_COMPLETED[lan], {fontFamily: "OpenSans-CondLight", fontSize: "22px", color: "#7C5D46"});
                notCompletedLabel.setOrigin(.5);
                this.add(notCompletedLabel);

                if (notCompletedLabel.width > 165) {
                    notCompletedLabel.setScale(165 / notCompletedLabel.width);
                }

            } else {

                const checkIcon = new Phaser.GameObjects.Image(this.scene, 80, -80, "texture_atlas_1", "check_icon");
                checkIcon.setScale(1);
                this.add(checkIcon);

                const timeLabel = new Phaser.GameObjects.Text(scene, 0, 80, gameText.TIME[lan] + ":" + GameVars.formatTime(time), {fontFamily: "OpenSans-CondLight", fontSize: "28px", color: "#7C5D46"});
                timeLabel.setOrigin(.5);
                this.add(timeLabel);
            }
    
        } else {

            const name = new Phaser.GameObjects.Text(scene, 0, 40, "?", {fontFamily: "OpenSans-CondLight", fontSize: "28px", color: "#7C5D46"});
            name.setOrigin(.5);
            this.add(name);

            const thumb = new Phaser.GameObjects.Image(scene, 0, -35, "texture_atlas_1", "locked_level");
            this.add(thumb);

            const notPlayedLabel = new Phaser.GameObjects.Text(scene, 0, 80,  gameText.NOT_PLAYED[lan], {fontFamily: "OpenSans-CondLight", fontSize: "22px", color: "#7C5D46"});
            notPlayedLabel.setOrigin(.5);
            this.add(notPlayedLabel);

            if (notPlayedLabel.width > 165) {
                notPlayedLabel.setScale(165 / notPlayedLabel.width);
            }

            this.alpha = .5;
        }
    }

    private onBoardUp(): void {

        if (CategoryLayer.currentInstance.scrolling) {
            return;
        }

        // mirar si el click esta dentro del area visible
        const x = this.scene.input.activePointer.x;
        const y = this.scene.input.activePointer.y;

        const maskRect = SplashScene.currentInstance.categoryLayer.maskRect;

        if (maskRect.contains(x, y)) {

            const self = this;

            const callbacks = {
                adFinished: () => {
                    if (!GameVars.gameData.muted) {
                        AudioManager.unmute();
                    }
                    GameManager.enterBoardScene(self.boardData.id);
                },
                adError: (error, errorData) =>  {
                    GameManager.enterBoardScene(self.boardData.id);
                },
                adStarted: () => {
                    if (!GameVars.gameData.muted) {
                        AudioManager.mute();
                    }
                }
            };

            const w = <any> window;
            w.CrazyGames.SDK.ad.requestAd("midgame", callbacks);
        } 
    }
}
